import { db } from '@/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Frontend logger that also sends important logs to Firestore.
 * This makes them visible in the Firebase Console.
 */
const logger = {
  info(message, data = {}) {
    console.info(message, data);
    return this._logToFirestore('INFO', message, data);
  },
  
  warn(message, data = {}) {
    console.warn(message, data);
    return this._logToFirestore('WARNING', message, data);
  },
  
  error(message, error = null, data = {}) {
    console.error(message, error, data);
    const logData = { ...data };
    if (error) {
      logData.errorMessage = error.message;
      logData.stack = error.stack;
    }
    return this._logToFirestore('ERROR', message, logData);
  },

  async _logToFirestore(severity, message, data) {
    // Only log warnings and errors to Firestore to avoid excessive writes
    if (severity === 'INFO') return Promise.resolve();

    try {
      return await addDoc(collection(db, 'logs'), {
        severity,
        message,
        data,
        timestamp: serverTimestamp(),
        url: window.location.href,
        userAgent: navigator.userAgent
      });
    } catch (e) {
      // Fail silently to avoid infinite loops if logging itself fails
      console.warn('Failed to send log to Firestore:', e);
    }
  }
};

export default logger;
